'use client';

import { useEffect } from 'react';

/**
 * セグメントレベルのエラーバウンダリ
 *
 * 目的:
 * - ルートセグメント内で発生したクライアントサイド例外を捕捉し、
 *   ユーザーにリトライ可能なフォールバックUIを表示する
 *
 * 引数:
 * - error: 発生したエラーオブジェクト
 * - reset: エラーバウンダリの再レンダーを試行する関数
 */
export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    // 本番環境では Sentry 等へ送信する想定
    console.error('[Error Boundary]', error);
  }, [error]);

  return (
    <div className='flex min-h-[50vh] flex-col items-center justify-center px-6'>
      <h2 className='mb-4 text-xl font-bold text-gray-800'>
        申し訳ございません。問題が発生しました
      </h2>
      <p className='mb-6 max-w-md text-center text-gray-600'>
        一時的な不具合の可能性があります。下のボタンから再度お試しください。
      </p>
      <button
        onClick={reset}
        className='rounded-full bg-primary px-8 py-3 font-bold text-white shadow-sm transition-colors hover:bg-primary/90'
      >
        再試行する
      </button>
    </div>
  );
}
